export enum VoteOptions {
	YES = 'yes',
	UNHELPFUL = 'unhelpful',
	UNSATISFIED = 'unsatisfied',
	OTHER = 'other',
}
